module.exports = __webpack_public_path__ + "img/designguide.1c2bae5.jpg";